import React from 'react';
import { Handle, useHandleConnections } from '@xyflow/react';

export const CustomHandle = ({ type, connectionCount, id, ...props }) => {
  const connections = useHandleConnections({ 
    type,
    id: id || props.id
  });
  
  let isConnectable = true;
  
  if (type === 'target') {
    // Alvo sem limite: sempre permite receber novas conexões
    isConnectable = true;
  } else if (connectionCount && type === 'source') {
    // Para handles source, usa a lógica original
    isConnectable = connections.length < connectionCount;
  }

  const className = isConnectable
    ? props.className
    : props.className?.replace('connectionindicator', '');

  return (
    <Handle
      {...props}
      type={type}
      id={id || props.id}
      isConnectable={isConnectable}
      className={className}
    >
      {props.content}
    </Handle>
  );
};